const styles = {
  // MAIN CONTENT
  breadcrumb: {
    '& .MuiBreadcrumbs-ol': {
      minHeight: theme => theme.spacing(3.5),
      mb: 4,
    },
  },
  linkBack: { ml: -1, mb: 1 },
  closeButton: {
    position: 'absolute',
    top: theme => theme.spacing(2),
    right: theme => theme.spacing(2),
    color: 'neutral.main',
  },
  mainTitle: {
    mb: 1,
  },
  mainDescription: {
    mb: 4,
    color: 'neutral.main',
  },
  paper: {
    mb: 4,
    pt: 0,
    px: 0,
    pb: 3,
  },
  section: {
    py: 4,
    px: 0,
  },
  titleContainer: {
    display: 'flex',
    mb: 11.25,
  },
  titleWrapper: {
    flex: 1,
    maxWidth: theme => theme.spacing(20),
  },
  title: {
    width: '100%',
    ml: theme => `calc(50% - ${theme.spacing(1.25)})`,
  },
  buttonContainer: {
    display: 'flex',
    pt: 5,
    pb: 3,
  },
  buttonWrapper: {
    flex: 1,
    maxWidth: theme => theme.spacing(20),
    position: 'relative',
  },
  button: {
    position: 'absolute',
    left: theme => `calc(50% - ${theme.spacing(1.25)})`,
    width: theme => theme.spacing(23.75),
  },
  fullTrackingButton: {
    position: 'absolute',
    left: theme => `calc(50% - ${theme.spacing(1.25)})`,
    width: 220,
  },
  fakeGap: {
    flex: 1,
    maxWidth: theme => theme.spacing(20),
  },

  // SUMMARY
  summary: {
    backgroundColor: { xs: 'neutral.lightest', sm: 'neutral.white' },
    px: 0,
    pt: { xs: 4, sm: 1 },
    pb: { xs: 3, sm: 0 },
    mb: { xs: 0, sm: 3 },
    position: { xs: 'sticky', sm: 'relative' },
    top: 0,
    zIndex: 2,
  },
  referenceAndLastUpdateContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    color: 'neutral.main',
    mb: 3.5,
  },
  divider: {
    borderColor: 'neutral.lighter',
    mb: 1.5,
  },
  summaryLabel: {
    mb: 1,
    color: 'neutral.main',
  },
  summaryNumberWrapper: {
    display: 'flex',
    alignItems: 'center',
    mb: { xs: 4, sm: 1 },
    a: {
      textDecoration: 'none',
      color: 'neutral.black',
    },
  },
  summaryNumber: {
    color: 'neutral.dark',
    mr: 1,
  },

  // ACTIONS
  actions: {
    display: 'flex',
    mb: 2,
  },

  actionsButtons: {
    marginLeft:'15px'
  },

  actionsSelect: {
    width: theme => theme.spacing(20),
    '& .MuiInput-root': {
      marginTop: 0,
    },
    '& .MuiFormHelperText-root': {
      display: 'none',
    },
  },

  actionsInput: {
    minWidth: theme => theme.spacing(36),
    mr: 3,
  },

  actionsLastButton: {
    ml: 'auto',
  },

  // FILTERS
  filters: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& .MuiChip-root': {
      mt: 0,
      mr: 2,
      mb: 2,
      ml: 0,
    },
    '& .MuiLink-root': {
      mt: 0,
      mr: 0,
      mb: 2.5,
      ml: 2,
    },
  },

  // ACTION BUTTONS
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    mb: 5,
  },

  actionButton: {
    ml: 2,
  },

  // TIMELINE
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: theme => theme.spacing(2),
    minHeight: 140,
    mt: 0.25,
    position: 'relative',

    '&::before': {
      content: '""',
      width: theme => theme.spacing(0.125),
      height: '100%',
      backgroundColor: 'green.main',
      position: 'absolute',
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  timelineError: {
    '&::after': {
      content: '""',
      width: theme => theme.spacing(0.125),
      height: theme => `calc(20% + ${theme.spacing(0.5)})`,
      backgroundColor: 'error.main',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  timelineSolved: {
    '&::after': {
      content: '""',
      width: theme => theme.spacing(0.125),
      height: theme => `calc(20% + ${theme.spacing(0.5)})`,
      backgroundColor: 'orange.main',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  point: {
    borderRadius: '50%',
    backgroundColor: 'success.main',
    position: 'relative',
    zIndex: 1,
    boxShadow: theme =>
      `0 0 0 ${theme.spacing(0.5)} ${theme.palette.neutral.white}`,
  },
  mainPoint: {
    width: theme => theme.spacing(2),
    height: theme => theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > svg': {
      width: theme => theme.spacing(1.5),
      height: theme => theme.spacing(1.5),
      color: 'green.darkest',
    },
  },
  mainPointError: {
    backgroundColor: 'primary.lightest',
    '& > svg': {
      width: theme => theme.spacing(1.5),
      height: theme => theme.spacing(1.5),
      color: 'error.dark',
    },
  },
  mainPointSolved: {
    backgroundColor: 'orange.lightest',
    '& > svg': {
      width: theme => theme.spacing(1.5),
      height: theme => theme.spacing(1.5),
      color: 'orange.dark',
    },
  },
  secondaryPoint: {
    width: theme => theme.spacing(0.75),
    height: theme => theme.spacing(0.75),
  },

  // ADDRESSES
  addresses: {
    pt: 5,
    px: 2,
    pb: 5,
    display: 'grid',
    gridTemplateColumns: theme => `${theme.spacing(2)} 1fr`,
    gridColumnGap: theme => theme.spacing(2),
  },
  addressesHasError: {
    pb: 11.5,
  },
  address: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme => theme.spacing(1),
    color: 'neutral.main',
  },
  addresFrom: { pb: 5.25 },
  addressTo: {
    gridArea: '2 / 2 / 3 / 3',
    mt: -2.25,
  },
}

export default styles
